module.exports = __webpack_public_path__ + "files/34a07354faf2ae6f4c64ca935f728fde.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-72x72.png
// module id = 1245
// module chunks = 76